import React, { useState, useRef } from "react";
import { Typography, TextField, Button } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { commentPost } from '../../actions/posts';

import useStyle from './styles';

const CommentSection = ({ post }) => {
    const classes = useStyle();
    const [comments, setComments] = useState(post?.comments || []);
    const [comment, setComment] = useState('');
    const [isCommentDisabled, setCommentDisabled] = useState(false);
    const dispatch = useDispatch();
    const user = JSON.parse(localStorage.getItem('profile')); 

    const handleClick = async () => {
        setCommentDisabled(true);
        const finalComment = `${user?.result.name}: ${comment}`;
        const newComments = await dispatch(commentPost(finalComment, post._id));
        setComments(newComments);
        setComment('');
        setCommentDisabled(false);
    }

    console.log(post);

    return (
        <div>
            <div>
                <div>
                    <Typography gutterBottom variant="h6">Comments</Typography>
                    {
                        comments.map((comment, index) => (
                            <Typography key={index} gutterBottom variant="subtitle1">
                                <strong>{comment.split(': ')[0]}: </strong>
                                {comment.split(': ')[1]}
                            </Typography>
                        ))
                    }
                </div>
                {
                    user &&  (
                        <div style={{ width: '70%' }}>
                            <Typography gutterBottom variant="h6">
                                Write a commnet:
                            </Typography>
                            <TextField
                                fullWidth
                                minRows={4}
                                variant='outlined'
                                label='Comment'
                                multiline
                                value={comment}
                                onChange={(e) => setComment(e.target.value)}
                            />
                            <Button style={{ marginTop: '10px' }} fullWidth disabled={isCommentDisabled || !comment} color='primary' variant='contained' onClick={handleClick}>
                                Comment
                            </Button>
                        </div>
                    )
                }
            </div>
        </div>
    );
}

export default CommentSection;